import { render, staticRenderFns } from "./verify-forgot.vue?vue&type=template&id=3e2312ac&lang=html&"
import script from "./verify-forgot.vue?vue&type=script&lang=js&"
export * from "./verify-forgot.vue?vue&type=script&lang=js&"
import style0 from "./verify-forgot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports